/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    arrayOf, func, number, object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import subscriptionConfig from '../../../../helpers/common/subscription/subscription-helpers';

const styles = () => ({
    dropdownLabel: {
        width: '100%',
        '& span': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 0',
            cursor: 'pointer',
        },
    },
    listContainer: {
        width: '100%',
        '& div': {
            borderTop: '1px solid rgb(0,0,0, 0.3)',
            padding: '10px 0',
            '&:hover': {
                backgroundColor: 'rgb(0,0,0, 0.05)',
                cursor: 'pointer',
            },
        },
    },
});

const FrequencyDropDown = ({
    classes,
    subscription,
    subscriptionsList,
    frequencyText,
    setFrequencyValue,
    updateSubscriptionList,
}) => {
    const [openFrequencyList, setOpenFrequencyList] = useState(false);

    const handleFrequencyDropDown = () => {
        setOpenFrequencyList(!openFrequencyList);
    };

    const frequencyDropdownList = Object.keys(subscriptionConfig?.['subscription_interval']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_interval'][item],
        };
        return obj;
    });

    const frequencyOptionList = frequencyDropdownList.filter((item) => subscriptionsList?.['interval']?.includes?.(item.id));

    const handleFrequencyChange = (frequency) => {
        setFrequencyValue(frequency.id);
        updateSubscriptionList({ ...subscription, interval: frequency.id });
        handleFrequencyDropDown();
    };

    return (
        <div>
            <div
                aria-hidden="true"
                onClick={handleFrequencyDropDown}
                className={classes.dropdownLabel}
            >
                <span>{frequencyText} {openFrequencyList ? <ExpandLessIcon /> : <ExpandMoreIcon />}</span>
            </div>
            <div className={classes.listContainer}>
                {openFrequencyList && frequencyOptionList.map((item) => (
                    <div
                        key={item.id}
                        aria-hidden="true"
                        onClick={() => handleFrequencyChange(item)}
                    >
                        {item?.value}
                    </div>
                ))}
            </div>
        </div>
    );
};

FrequencyDropDown.propTypes = {
    classes: object.isRequired,
    subscription: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    frequencyText: string.isRequired,
    setFrequencyValue: func,
    updateSubscriptionList: func,
};

FrequencyDropDown.defaultProps = {
    updateSubscriptionList: () => {},
    setFrequencyValue: () => {},
};

export default withStyles(styles)(FrequencyDropDown);
